const messages = {
	pt: {
		translations: {
			common: {
				cancel: "Cancelar",
				save: "Salvar",
				close: "Fechar",
				none: "Nenhum",
			},
			allTicket: {
				form: {
					viewTags: "Todos os tickets",
				},
			},
			activityTypes: {
				confirmationModal: {
					deleteTitle: "Excluir Tipo de Atividade",
					deleteMessage: "Tem certeza que deseja excluir este tipo de atividade?",
				},
				toasts: {
					created: "Tipo de atividade criado!",
					updated: "Tipo de atividade atualizado!",
					deleted: "Tipo de atividade excluído!",
				},
			},
			connections: {
				needsAttention: "requer atenção",
				title: "Conexões",
				noConnections: "Nenhuma conexão configurada",
				table: {
					name: "Nome",
					status: "Status",
					session: "Sessão",
					lastUpdate: "Última atualização",
					default: "Padrão",
					actions: "Ações"
				},
				buttons: {
					add: "Adicionar WhatsApp",
					edit: "Editar",
					delete: "Excluir",
					disconnect: "Desconectar",
					tryAgain: "Tentar novamente",
					newQr: "Novo QR Code",
					qrcode: "QR Code",
					message: "Enviar mensagem",
					connecting: "Conectando"
				},

				status: {
					connected: "Conectado",
					disconnected: "Desconectado",
					connecting: "Conectando",
					qrcode: "QR Code",
					timeout: "Timeout"
				},
				providerType: {
					label: "Tipo de Conexão",
					baileys: "WhatsApp Web",
					cloudApi: "WhatsApp API Oficial",
					official: "API Oficial"
				},
				confirmationModal: {
					disconnectTitle: "Desconectar WhatsApp",
					disconnectMessage: "Tem certeza que deseja desconectar este WhatsApp?",
					deleteTitle: "Excluir WhatsApp",
					deleteMessage: "Tem certeza que deseja excluir este WhatsApp? Esta ação não pode ser desfeita."
				},
				toasts: {
					deleted: "WhatsApp excluído com sucesso!"
				},
				default: "Padrão",
				toolTips: {
					disconnected: {
						title: "Falha ao iniciar sessão",
						content: "Certifique-se de que o celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code"
					},
					qrcode: {
						title: "Esperando leitura do QR Code",
						content: "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão"
					},
					connected: {
						title: "Conexão estabelecida!"
					},
					timeout: {
						title: "A conexão com o celular foi perdida",
						content: "Certifique-se de que o celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code"
					}
				}
			},
			legal: {
				terms: "Termos de Serviço",
				privacy: "Política de Privacidade",
				deletion: "Exclusão de Dados",
			},
			documentModal: {
				title: "Enviar Documento para Assinatura",
				documentInfo: "Informações do Documento",
				documentTitleLabel: "Título do Documento",
				signers: "Signatários",
				signerLabel: "Signatário",
				signerNameLabel: "Nome do Signatário",
				emailLabel: "E-mail",
				whatsappLabel: "WhatsApp",
				whatsappTooltipPrimary: "Insira o WhatsApp para disparar o link.",
				whatsappTooltipSecondary: "Insira o WhatsApp para disparar o link.",
				addSigner: "Adicionar signatário",
				documentOptions: "Opções do Documento",
				orderLabel: "Ordem",
				enabled: "Habilitado",
				disabled: "Desabilitado",
				visibleSignatureLabel: "Assinatura visível",
				signatureAppearanceLabel: "Aparência da assinatura",
				signatureAppearanceDefault: "Indefinido",
				sendMethodLabel: "Método de envio",
				sendMethodLink: "Link",
				sendMethodEmail: "E-mail",
				sendMethodWhatsapp: "WhatsApp",
				footerLabel: "Marcação eletrônica",
				footerNone: "Sem marcação",
				folderSection: "Arquivo & Pasta",
				folderTypeLabel: "Tipo da Pasta",
				folderLabel: "Pasta",
				folderNone: "Padrão (Raiz)",
				folderEmpty: "Nenhuma pasta disponível",
				newFolderLabel: "Nova Pasta",
				folderTypeRegular: "Minhas Pastas",
				folderTypeOrganization: "Pastas da Organização",
				createFolderSuccess: "Pasta criada com sucesso!",
				createFolderError: "Erro ao criar pasta",
				loadFolderError: "Erro ao carregar pastas"
			},
			selectLanguage: "Selecionar Idioma",
			signup: {
				title: "Cadastrar",
				toasts: {
					success: "Usuário criado com sucesso! Por favor faça login!!!",
					fail: "Erro ao criar usuário. Verifique as informações fornecidas.",
				},
				form: {
					name: "Nome da Empresa",
					cpfCnpj: "CPF/CNPJ",
					email: "Email",
					phone: "Telefone (com DDD)",
					plan: "Plano",
					password: "Senha",
					passwordHint: "Mínimo 8 caracteres, com maiúscula, minúscula e número",
				},
				formErrors: {
					cpfCnpj: {
						required: "CPF/CNPJ é obrigatório",
						invalid: "CPF/CNPJ inválido",
					},
					name: {
						required: "Nome da empresa é obrigatório",
						short: "Nome muito curto",
						long: "Nome muito longo",
					},
					password: {
						short: "Senha muito curta (mínimo 8 caracteres)",
						long: "Senha muito longa",
						required: "Senha é obrigatória",
						weak: "A senha deve ter no mínimo 8 caracteres, incluindo maiúscula, minúscula e número",
					},
					phone: {
						required: "Telefone é obrigatório",
					},
					plan: {
						required: "Plano é obrigatório",
					},
					email: {
						required: "Email é obrigatório",
						invalid: "Email inválido",
					},
				},
				buttons: {
					submit: "Cadastrar",
					login: "Já tem uma conta? Faça login!",
				},
				plan: {
					attendant: "Atendente",
					whatsapp: "WhatsApp",
					queues: "Filas",
				},
			},
			login: {
				title: "Login",
				form: {
					email: "Email",
					password: "Senha",
				},
				buttons: {
					submit: "Entrar",
					register: "Cadastre-se agora!",
					forgot: "Esqueci a senha",
				},
			},
			resetPassword: {
				title: "Redefinir Senha",
				toasts: {
					emailSent: "Email enviado com sucesso!",
					emailNotFound: "Email não encontrado!",
					passwordUpdated: "Senha atualizada com sucesso!",
				},
				formErrors: {
					email: {
						required: "Email é obrigatório",
						invalid: "Email inválido",
					},
					newPassword: {
						required: "Nova senha é obrigatória",
						matches: "Sua senha deve ter pelo menos 8 caracteres, incluindo uma letra maiúscula, uma letra minúscula e um número.",
					},
					confirmPassword: {
						required: "Confirmação de senha é obrigatória",
						matches: "As senhas não conferem",
					},
				},
				form: {
					email: "Email",
					verificationCode: "Código de Verificação",
					newPassword: "Nova Senha",
					confirmPassword: "Confirmar Nova Senha",
				},
				buttons: {
					submitEmail: "Enviar Email",
					submitPassword: "Redefinir Senha",
					resendCode: "Reenviar código",
					resendCooldown: "Reenviar código em {{seconds}}s",
					back: "Não tem uma conta? Cadastre-se!",
				},
			},
			dashboard: {
				title: "Painel de controle",
				pipelineWon: "Total em Vendas",
				pipelineLost: "Total em Perdas",
				conversionRate: "Taxa de Conversão",
				toasts: {
					selectFilterError: "Defina os parâmetros do filtro",
					userChartError: "Erro ao obter informações de conversas",
					dateChartError: "Erro ao obter informações de conversas",
				},
				filters: {
					title: "Filtros",
					initialDate: "Data Inicial",
					finalDate: "Data Final",
					kanbanBoard: "Quadro Kanban",
					allKanbanBoards: "Todos os quadros",
					filterType: {
						title: "Tipo de Filtro",
						options: {
							perDate: "Filtrar por Data",
							perPeriod: "Filtrar por Período",
						},
						helper: "Selecione o tipo de filtro desejado",
					},
				},
				performanceIndicators: {
					axisLeft: "Eixo esquerdo",
					axisRight: "Eixo direito",
					none: "Nenhum",
					tickets: "Atendimentos",
					wonCount: "Número de Vendas",
					lostCount: "Número de Perdas",
					wonValue: "Valor Faturado",
					lostValue: "Valor Perdido",
					conversionRate: "Taxa de Conversão",
					avgSupportTime: "Tempo médio de atendimento",
					avgConversionTime: "Tempo médio de conversão",
				},
				periodSelect: {
					title: "Período",
					options: {
						none: "Nenhum selecionado",
						last3: "Últimos 3 dias",
						last7: "Últimos 7 dias",
						last15: "Últimos 15 dias",
						last30: "Últimos 30 dias",
						last60: "Últimos 60 dias",
						last90: "Últimos 90 dias",
					},
					helper: "Selecione o período desejado",
				},
				counters: {
					inTalk: "Em atendimento",
					waiting: "Aguardando",
					finished: "Finalizados",
					newContacts: "Novos contatos",
					averageTalkTime: "Tempo Médio de Atendimento",
					averageWaitTime: "Tempo Médio de Espera",
				},
				buttons: {
					filter: "Filtrar",
				},
				onlineTable: {
					ratingLabel: "1 - Insatisfeito, 2 - Satisfeito, 3 - Muito Satisfeito",
					name: "Nome",
					ratings: "Avaliações",
					avgSupportTime: "Tempo Médio de Suporte",
					status: "Status (Atual)",
				},
				charts: {
					performanceTitle: "Performance dos Atendentes",
					performanceSubtitle: "Atendimentos realizados no período",
					statusDistribution: "Distribuição de Status",
					totalTickets: "Total de Atendimentos",
					user: {
						label: "Gráfico de Conversas",
						title: "Total de Conversas por Usuários",
						start: "Início",
						end: "Fim",
						filter: "Filtrar",
					},
					date: {
						label: "Gráfico de Conversas",
						title: "Total",
						start: "Início",
						end: "Fim",
						filter: "Filtrar",
					},
				},
				status: {
					finished: "Finalizados",
					inProgress: "Em Andamento",
					pending: "Pendentes",
					online: "Online",
					offline: "Offline"
				},
				attendants: {
					title: "Status dos Atendentes",
					active: "atendentes ativos",
					tableHeaders: {
						attendant: "Atendente",
						status: "Status",
						tickets: "Atendimentos",
						avgTime: "Tempo Médio",
						completionRate: "Taxa de Conclusão"
					},
					finished: "finalizados",
					perService: "por atendimento",
					totalTickets: "Total de Atendimentos",
					generalAvgTime: "Tempo Médio Geral"
				},
				metrics: {
					vsLastPeriod: "vs período anterior",
					totalContacts: "Total de contatos",
					avgTime: "Tempo médio"
				},
				averageTalkTime: "Tempo Médio de Atendimento",
				averageWaitTime: "Tempo Médio de Espera",
				noData: {
					performance: "Nenhum dado de performance disponível",
					tickets: "Nenhum atendimento no período selecionado"
				}
			},
			datePicker: { openDate: "Selecionar data", openTime: "Selecionar horário", time: "Horário", timeHint: "Informe o horário no formato HH:mm", clear: "Limpar", apply: "Aplicar" },
			plans: {
				newPlan: "Novo Plano",
				editPlan: "Editar Plano",
				registeredPlans: "Planos Cadastrados",
				toasts: {
					errorList: "Não foi possível carregar a lista de registros",
					errorOperation: "Não foi possível concluir a operação",
					error: "Não foi possível concluir a operação. Verifique se já existe um plano com o mesmo nome ou se os campos foram preenchidos corretamente",
					success: "Operação concluída com sucesso!",
				},
				confirm: {
					title: "Excluir Registro",
					message: "Você realmente deseja excluir este registro?",
				},
				form: {
					features: "Recursos",
					name: "Nome",
					users: "Usuários",
					connections: "Conexões",
					queues: "Filas",
					value: "Valor",
					internalChat: "Chat Interno",
					externalApi: "API Externa",
					kanban: "Kanban",
					integrations: "Integrações",
					automation: "Automação",
					campaigns: "Campanhas",
					schedules: "Agendamentos",
					enabled: "Habilitado",
					disabled: "Desabilitado",
					clear: "Cancelar",
					delete: "Excluir",
					save: "Salvar",
					yes: "Sim",
					no: "Não",
					money: "R$",
				},
			},
			activityAssignee: {
				title: "Responsável pela atividade",
				noAssignee: "Sem responsável",
				ticketOwner: "Proprietário do ticket",
				allUsers: "Todos",
			},
			kanban: {
				toasts: {
					unreadPositionAdjusted: "Card reposicionado para respeitar a prioridade dos não lidos.",
					movePending: "Aguarde a confirmação da movimentação anterior.",
					moveConnectionFailed: "Não foi possível confirmar a movimentação. Verifique a conexão e tente novamente.",
					removed: "Tag do Ticket Removida!",
					added: "Tag do Ticket Adicionada com Sucesso!",
					columnReordered: "Etapa reordenada com sucesso",
					reorderError: "Erro ao reordenar etapa",
					permissionDenied: "Sem permissão para reordenar etapas",
					columnDeleted: "Etapa excluída com sucesso",
					archived: "Card arquivado com sucesso!",
					restored: "Card restaurado com sucesso!",
					resolvedWon: "Marcado como Ganho!",
					resolvedLost: "Marcado como Perda!",
				},
				outcome: {
					label: "Resultado",
					open: "Em aberto",
					won: "Ganho",
					lost: "Perda",
					save: "Salvar resultado",
				},
				archiveOnResolve: "Arquivar ao definir resultado",
				dropToWin: "Soltar aqui para marcar como Ganho",
				dropToLose: "Soltar aqui para marcar como Perda",
				dropToArchive: "Soltar aqui para arquivar",
				dropToRemoveFromStage: "Soltar aqui para excluir da etapa",
				dropToClose: "Soltar aqui para fechar",
				dropToCloseAndRemove: "Soltar aqui para fechar e excluir",
				dropNoCardXAction: "Sem ação configurada no X",
				drawer: {
					all: "Todos",
					won: "Ganhos",
					lost: "Perdas",
				},
				description: "Descrição",
				information: "Informações",
				activity: "Comentários e atividade",
				noActivity: "Nenhuma atividade registrada",
				board: "Quadro",
				comment: {
					placeholder: "Escreva um comentário",
				},
				column: {
					addTitle: "Nova Etapa",
					deleteTitle: "Excluir Etapa",
					deleteMessage: "Tem certeza que deseja excluir esta etapa?",
					options: "Opções da Etapa"
				},
				addColumn: "+ Adicionar nova etapa",
				open: "Aberto",
				seeTicket: "Visualizar Ticket",
				selectBoard: "Selecionar quadro",
				noBoards: "Nenhum quadro cadastrado",
				createNew: "➕ Criar novo...",
				column: {
					addTitle: "Nova Etapa",
					deleteTitle: "Excluir etapa",
					deleteMessage: "Tem certeza que deseja excluir esta etapa{{name}}?",
					delete: "Excluir etapa",
					collapse: "Recolher etapa",
					expand: "Expandir etapa",
					addTicket: "Adicionar card",
					options: "Opções da Etapa"
				},
				actions: {
					new: "Novo",
					edit: "Editar",
					delete: "Excluir",
				},
				boardModal: {
					new: "Novo quadro",
					edit: "Editar quadro",
					name: "Nome do quadro",
					cancel: "Cancelar",
					save: "Salvar",
					create: "Criar",
					showCardCountCompact: "Quantidade de Cards",
					showCardValueSumCompact: "Soma de valores",
					showCardCount: "Mostrar quantidade de Cards nas etapas",
					showCardValueSum: "Mostrar soma dos valores nas etapas",
					isManualSorting: "Ordenação Manual",
					prioritizeUnread: "Não lidos",
					openTicketOnCardAdd: "Abrir atendimento ao adicionar pelo Kanban",
					showClosedTicketsInArchived: "Incluir atendimentos fechados nos arquivados",
					enableOutcomeTracking: "Modo CRM",
					showCardTags: "Tags nos cards",
					showCardPhone: "Telefone nos cards",
					showCardLastMessage: "Ultima mensagem nos cards",
					showCardValue: "Valor nos cards",
					deleteTitle: "Excluir quadro",
					deleteMessage: "Deseja realmente excluir este quadro? As tags vinculadas voltarão a não ter kanban.",
					saved: "Quadro salvo com sucesso.",
					deleted: "Quadro excluído com sucesso.",
					generalSettings: "Geral",
					displaySettings: "Exibição",
					tickets: "Tickets",
					cards: "Cards",
					tags: "Tags",
					phone: "Telefone",
					lastMessage: "Última Mensagem",
					value: "Valor",
					description: "Descrição",
				},
				ticketModal: {
					title: "Editar Ticket",
					description: "Descrição",
					value: "Valor",
					success: "Ticket atualizado com sucesso!",
				},
				assignUser: "Atribuir responsável",
				noUser: "Sem responsável",
				userAssigned: "Responsável atualizado!",
				linkTicket: "Vincular ticket",
				archived: {
					title: "Arquivados",
					empty: "Nenhum item arquivado",
					restore: "Restaurar",
					restoreSuccess: "Card restaurado com sucesso!",
					ticketRestoreSuccess: "Ticket reaberto com sucesso!",
					viewArchived: "Ver Arquivados",
					delete: "Excluir permanentemente",
					deleteSuccess: "Item excluído da lista de arquivados.",
					archivedAt: "Arquivado em",
					archivedBy: "Arquivado por",
					card: "Card",
					ticket: "Ticket",
					closedTicket: "Ticket fechado",
					reopenTicket: "Reabrir ticket"
				},
			},
			invoices: {
				title: "Financeiro",
				paid: "Pago",
				open: "Aberto",
				expired: "Vencido",
				details: "Detalhes",
				value: "Valor",
				dueDate: "Data de Vencimento",
				status: "Status",
				action: "Ação",
				PAY: "PAGAR",
				PAID: "PAGO",
				missingCheckoutLink: "Não encontramos um link de pagamento para esta fatura. Entre em contato com o suporte.",
				accountRestricted: "Seu acesso está limitado porque sua assinatura está pendente. Regularize o pagamento para liberar todas as funcionalidades.",
			},
			checkoutPage: {
				steps: {
					data: "Dados",
					customize: "Personalizar",
					review: "Revisar",
				},
				success: "Assinatura concluída com sucesso! Aguardando confirmação de pagamento",
				closeToEnd: "Quase lá!",
				BACK: "VOLTAR",
				PAY: "PAGAR",
				NEXT: "PRÓXIMO",
				review: {
					title: "Resumo da Assinatura",
					details: "Detalhes do Plano",
					users: "Usuários",
					whatsapp: "WhatsApp",
					charges: "Cobrança: Mensal",
					total: "Total",
				},
				form: {
					firstName: {
						label: "Nome Completo*",
						required: "Nome completo é obrigatório",
					},
					lastName: {
						label: "Sobrenome*",
						required: "Sobrenome é obrigatório",
					},
					address1: {
						label: "Endereço*",
						required: "Endereço é obrigatório",
					},
					city: {
						label: "Cidade*",
						required: "Cidade é obrigatória",
					},
					state: {
						label: "Estado*",
						required: "Estado é obrigatório",
					},
					zipcode: {
						label: "CEP*",
						required: "CEP é obrigatório",
						invalid: "Formato de CEP inválido",
					},
					country: {
						label: "País*",
						required: "País é obrigatório",
					},
					useAddressForPaymentDetails: {
						label: "Usar este endereço para detalhes de pagamento",
					},
					invoiceId: {
						label: "Usar este ID de fatura",
					},
					nameOnCard: {
						label: "Nome no Cartão*",
						required: "Nome no cartão é obrigatório",
					},
					cardNumber: {
						label: "Número do Cartão*",
						required: "Número do cartão é obrigatório",
						invalid: "Número de cartão inválido (ex: 4111111111111)",
					},
					expiryDate: {
						label: "Data de Validade*",
						required: "Data de validade é obrigatória",
						invalid: "Data de validade inválida"
					},
					cvv: {
						label: "CVV*",
						required: "CVV é obrigatório",
						invalid: "CVV inválido (ex: 123)",
					},
				},
				pricing: {
					users: "Usuários",
					connection: "Conexão",
					queues: "Filas",
					SELECT: "SELECIONAR",
					month: "mês",
				},
			},
			companies: {
				title: "Registrar Empresa",
				form: {
					name: "Nome da Empresa",
					plan: "Plano",
					token: "Token",
					submit: "Registrar",
					success: "Empresa criada com sucesso!",
				},
			},
			auth: {
				toasts: {
					success: "Login efetuado com sucesso!",
					permissionsUpdated: "Suas permissões foram atualizadas. Recarregando...",
				},
				companyInactive: "Sua empresa está com acesso restrito. Regularize a assinatura para voltar a utilizar todas as funcionalidades.",
				companyOverdue: "Sua assinatura está vencida. Acesse o Financeiro para regularizar.",
				token: "Token",
			},
			whatsappModal: {
				title: {
					add: "Adicionar WhatsApp",
					edit: "Editar WhatsApp",
				},
				formErrors: {
					name: {
						required: "Nome é obrigatório",
						short: "Nome muito curto",
						long: "Nome muito longo",
					},
					cloudApiPhoneNumberId: {
						required: "Número de telefone da Cloud API é obrigatório",
					},
					cloudApiAccessToken: {
						required: "Token de acesso da Cloud API é obrigatório",
					},
				},
				tabs: {
					general: "Geral",
					messages: "Mensagens",
					assessments: "Avaliações",
					integrations: "Integrações",
					schedules: "Horário de Funcionamento",
				},
				form: {
					name: "Nome",
					default: "Padrão",
					sendIdQueue: "Fila",
					timeSendQueue: "Redirecionar para fila em X minutos",
					queueRedirection: "Redirecionamento de Fila",
					outOfHoursMessage: "Mensagem fora do expediente",
					queueRedirectionDesc: "Selecione uma fila para que contatos sem fila sejam redirecionados",
					prompt: "Prompt",
					queue: "Fila de Transferência",
					timeToTransfer: "Transferir após x (minutos)",
					expiresTicket: "Fechar chats abertos após x minutos",
					expiresInactiveMessage: "Mensagem de fechamento por inatividade",
					greetingMessage: "Mensagem de saudação",
					complationMessage: "Mensagem de conclusão",
					integration: "Integração",
					initialTag: "Tag inicial",
					noInitialTag: "Nenhuma",
					providerType: "Tipo de Conexão",
					cloudApiPhoneNumberId: "Número de telefone da Cloud API",
					cloudApiAccessToken: "Token de acesso da Cloud API",
					cloudApiBusinessAccountId: "Business Account ID",
					cloudApiPhoneNumberIdHelp: "Use o Phone Number ID da Meta (não o número em si).",
					cloudApiAccessTokenHelp: "Token salvo e oculto. Preencha apenas se for atualizar.",
					noQueue: "Nenhum",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
				success: "WhatsApp salvo com sucesso.",
			},
			qrCodeModal: {
				title: "Use seu WhatsApp:",
				steps: {
					one: "1 - Abra o WhatsApp no seu celular",
					two: {
						partOne: "2 - Toque em Mais opções no Android",
						partTwo: "ou Configurações",
						partThree: "no iPhone",
					},
					three: "3 - Toque em Aparelhos conectados e depois em Conectar um aparelho",
					four: "4 - Aponte seu telefone para esta tela para capturar o QR Code",
				},
				waiting: "Aguardando leitura do QR Code",
			},
			qrCode: {
				message: "Escaneie o QR Code para iniciar a sessão",
			},
			contacts: {
				noResults: "Nenhum contato encontrado",
				title: "Contatos",
				toasts: {
					deleted: "Contato excluído com sucesso!",
					deletedAll: "Todos os contatos foram excluídos com sucesso!",
				},
				searchPlaceholder: "Pesquisar...",
				noContacts: "Nenhum contato cadastrado",
				confirmationModal: {
					deleteTitle: "Excluir ",
					deleteAllTitle: "Excluir Todos",
					importTitle: "Importar contatos",
					importTitlte: "Importar contatos",
					deleteMessage: "Tem certeza que deseja excluir este contato? Todos os tickets relacionados serão perdidos.",
					deleteAllMessage: "Tem certeza que deseja excluir todos os contatos? Todos os tickets relacionados serão perdidos.",
					importMessage: "Deseja importar todos os contatos do telefone?",
				},
				buttons: {
					import: "Importar Contatos",
					add: "Adicionar Contato",
					export: "Exportar Contatos",
					importShort: "Importar",
					exportShort: "Exportar",
					delete: "Excluir Todos Contatos",
					message: "Enviar mensagem",
					edit: "Editar",
				},
				table: {
					name: "Nome",
					whatsapp: "WhatsApp",
					email: "Email",
					actions: "Ações",
				},
			},
			contactImportModal: {
				title: "Planilha de Contatos",
				labels: {
					import: "Importar contatos",
					result: "resultados",
					added: "Adicionados",
					savedContact: "Contato salvo",
					errors: "Erros",
				},
				buttons: {
					download: "Baixar planilha modelo",
					import: "Importar contatos",
				},
			},
			queueIntegrationModal: {
				title: {
					add: "Adicionar projeto",
					edit: "Editar projeto",
				},
				form: {
					id: "ID",
					type: "Tipo",
					name: "Nome",
					projectName: "Nome do Projeto",
					language: "Idioma",
					jsonContent: "JsonContent",
					urlN8N: "URL",
					typebotSlug: "Typebot - Slug",
					typebotExpires: "Tempo (min) para expirar uma conversa",
					typebotKeywordFinish: "Palavra-chave para finalizar ticket",
					typebotKeywordRestart: "Palavra-chave para reiniciar fluxo",
					typebotRestartMessage: "Mensagem ao reiniciar conversa",
					typebotUnknownMessage: "Mensagem de opção inválida",
					typebotDelayMessage: "Intervalo (ms) entre mensagens",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
					test: "Testar Bot",
				},
				messages: {
					testSuccess: "Integração testada com sucesso!",
					addSuccess: "Integração adicionada com sucesso.",
					editSuccess: "Integração editada com sucesso.",
				},
			},
			sideMenu: {
				name: "Menu Lateral Inicial",
				note: "Se ativado, o menu lateral iniciará fechado",
				options: {
					enabled: "Aberto",
					disabled: "Fechado",
				},
			},
			promptModal: {
				form: {
					name: "Nome",
					prompt: "Prompt",
					model: "Modelo",
					max_tokens: "Máximo de palavras na resposta",
					temperature: "Temperatura",
					apikey: "Chave API",
					max_messages: "Máximo de mensagens no Histórico",
					voice: "Voz",
					voiceKey: "Chave API de voz",
					voiceRegion: "Região da voz",
					responseType: "Tipo de resposta",
					responseTypeText: "Texto",
					responseTypeVoice: "Voz",
					elevenLabsKey: "Chave ElevenLabs",
					elevenLabsVoice: "Voz ElevenLabs",
				},
				formErrors: {
					name: {
						short: "Nome muito curto",
						long: "Nome muito longo",
						required: "Nome é obrigatório",
					},
					prompt: {
						short: "Prompt muito curto",
						required: "Descreva o treinamento para a Inteligência Artificial",
					},
					model: {
						required: "Informe o modelo desejado para o Prompt",
					},
					maxWords: {
						required: "Informe o máximo de palavras na resposta",
					},
					temperature: {
						required: "Informe a temperatura",
					},
					apikey: {
						required: "Informe a Chave API",
					},
					queueId: {
						required: "Informe a fila",
					},
					maxMessages: {
						required: "Informe o máximo de mensagens no histórico",
					},
				},
				success: "Prompt salvo com sucesso!",
				setor: "Informe o setor",
				title: {
					add: "Adicionar Agente",
					edit: "Editar Agente",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
			},
			prompts: {
				title: "Agentes",
				table: {
					name: "Nome",
					queue: "Setor/Fila",
					max_tokens: "Máximo de palavras na Resposta",
					actions: "Ações",
				},
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteMessage: "Tem certeza? Esta ação não pode ser desfeita!",
				},
				buttons: {
					add: "Adicionar Agente",
				},
			},
			contactModal: {
				title: {
					add: "Adicionar Contato",
					edit: "Editar Contato",
				},
				form: {
					mainInfo: "Dados do Contato",
					extraInfo: "Informações Adicionais",
					name: "Nome",
					number: "Número do WhatsApp",
					email: "Email",
					extraName: "Nome do Campo",
					extraValue: "Valor",
					whatsapp: "Conexão Origem: ",
				},
				formErrors: {
					name: {
						required: "Nome é obrigatório",
						short: "Nome muito curto",
						long: "Nome muito longo",
					},
					phone: {
						short: "Número muito curto",
						long: "Número muito longo",
					},
					email: {
						invalid: "Email inválido",
					},
				},
				buttons: {
					addExtraInfo: "Adicionar Informação",
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
				success: "Contato salvo com sucesso.",
			},
			queueModal: {
				title: {
					add: "Adicionar Fila",
					edit: "Editar Fila",
				},
				form: {
					name: "Nome",
					nameShort: "Nome curto",
					nameLong: "Nome longo",
					nameRequired: "Nome é obrigatório",
					color: "Cor",
					colorShort: "Cor curta",
					colorLong: "Cor longa",
					greetingMessage: "Mensagem de saudação",
					complationMessage: "Mensagem de conclusão",
					outOfHoursMessage: "Mensagem fora do expediente",
					ratingMessage: "Mensagem de avaliação",
					token: "Token",
					orderQueue: "Ordem da fila (Bot)",
					integrationId: "Integração",
					initialTag: "Tag inicial",
					noInitialTag: "Nenhuma",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
				toasts: {
					success: "Fila salva com sucesso.",
					info: "Clique em salvar para registrar alterações",
				},
				tabs: {
					queueData: "Dados da Fila",
					attendanceTime: "Horários de Atendimento",
				},
			},
			avatarUpload: {
				title: "Alterar foto de perfil",
				selectImage: "Selecione uma imagem para usar como avatar",
				chooseFile: "Escolher imagem",
				changeImage: "Escolher outra imagem",
				save: "Salvar",
				cancel: "Cancelar",
				success: "Avatar atualizado com sucesso!",
				deleteSuccess: "Avatar removido com sucesso!",
				deleteAvatar: "Remover avatar",
				errors: {
					fileTooLarge: "Arquivo muito grande. Máximo 5MB.",
					invalidType: "Tipo de arquivo inválido. Use JPEG, PNG, GIF ou WebP.",
				},
			},
			userModal: {
				title: {
					add: "Adicionar Usuário",
					edit: "Editar Usuário",
				},
				changeAvatar: "Clique para alterar a foto",
				form: {
					name: "Nome",
					email: "Email",
					password: "Senha",
					profile: "Perfil",
					whatsapp: "Conexão Padrão",
					allTicket: "Todos os tickets",
					allTicketEnabled: "Habilitado",
					allTicketDesabled: "Desabilitado",
					viewPendingTickets: "Modo de visualização",
					viewPendingTicketsEnabled: "Habilitado",
					viewPendingTicketsDisabled: "Desabilitado",
					companyQuickMessages: "Respostas rápidas da empresa",
					companyQuickMessagesEnabled: "Habilitado",
					companyQuickMessagesDisabled: "Desabilitado",
					allowTagEdit: "Edição em Tags",
					allowTagEditEnabled: "Habilitado",
					allowTagEditDisabled: "Desabilitado",
				},
				formErrors: {
					name: {
						required: "Nome é obrigatório",
						short: "Nome muito curto",
						long: "Nome muito longo",
					},
					password: {
						short: "Senha muito curta",
						long: "Senha muito longa",
					},
					email: {
						required: "Email é obrigatório",
						invalid: "Email inválido",
					},
				},
				labels: {
					liberations: "Liberações",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
				success: "Usuário salvo com sucesso.",
			},
			scheduleModal: {
				title: {
					add: "Novo Agendamento",
					edit: "Editar Agendamento",
				},
				form: {
					body: "Mensagem",
					contact: "Contato",
					sendAt: "Data de Agendamento",
					sentAt: "Data de Envio",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
				confirmationModal: {
					deleteTitle: "Excluir Agendamento",
					deleteMessage: "Tem certeza que deseja excluir este agendamento?",
				},
				success: "Agendamento salvo com sucesso.",
			},
			tagModal: {
				title: {
					add: "Nova Tag",
					edit: "Editar Tag",
					editStage: "Editar Etapa",
				},
				form: {
					name: "Nome",
					color: "Cor",
					board: "Quadro do Kanban",
					noBoard: "Sem quadro",
					showClosedTickets: "Incluir tickets finalizados nesta etapa do Kanban",
					showClosedTicketsDisabledTooltip: "Este quadro gerencia negócios. Cards encerrados aparecem nas abas Ganhos ou Perdas, com histórico preservado.",
					closeTicketOnCardX: "Fechar ticket ao clicar no \"X\" do Card",
					removeTagOnCardX: "Remover tag ao clicar no \"X\" do Card",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
				success: "Tag salva com sucesso.",
			},
			chat: {
				toasts: {
					fillTitle: "Por favor, preencha o título da conversa.",
					fillUser: "Por favor, selecione pelo menos um usuário.",
				},
				modal: {
					title: "Conversa",
					titleField: "Título",
				},
				confirm: {
					title: "Excluir Conversa",
					message: "Esta ação não pode ser desfeita, confirma?",
				},
				chats: "Conversas",
				messages: "Mensagens",
				noTicketMessage: "Selecione um ticket para começar a conversar.",
				buttons: {
					close: "Fechar",
					save: "Salvar",
					new: "Novo",
					newChat: "Novo",
				},
			},
			drafts: {
				label: "Rascunho",
			},
			uploads: {
				titles: {
					titleUploadMsgDragDrop: "ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO",
					titleFileList: "Lista de Arquivos",
				},
				toasts: {
					imageTooLarge: "Imagens podem ter no máximo {{limit}}MB.",
					videoTooLarge: "Vídeos podem ter no máximo {{limit}}MB.",
					audioTooLarge: "Áudios podem ter no máximo {{limit}}MB.",
					documentTooLarge: "Documentos podem ter no máximo {{limit}}MB.",
					genericTooLarge: "Arquivo excede o limite permitido.",
					fileTooLarge: "Arquivo excede o limite permitido.",
				},
			},
			ticketsManager: {
				buttons: {
					newTicket: "Novo",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Filas",
			},
			tickets: {
				title: "Tickets",
				toasts: {
					deleted: "O atendimento que você estava foi excluído.",
					unauthorized: "Acesso não permitido",
				},
				filters: {
					user: "Filtrar por usuários",
					tags: "Filtrar por tags",
					userPlaceholder: "Usuários",
					tagsPlaceholder: "Tags",
				},
				notification: {
					message: "Mensagem de",
				},
				tabs: {
					open: { title: "Abertos" },
					closed: { title: "Resolvidos" },
					search: { title: "Busca" },
				},
				search: {
					placeholder: "Buscar tickets e mensagens",
					sections: {
						tickets: "Tickets",
						messages: "Mensagens",
					},
					mediaChips: {
						photos: "Fotos",
						videos: "Vídeos",
						links: "Links",
						documents: "Documentos",
					},
				},
				buttons: {
					showAll: "Todos",
					unreadFirst: "Não lidos",
				},
			},
			transferTicketModal: {
				title: "Transferir Ticket",
				fieldLabel: "Digite para buscar usuários",
				fieldQueueLabel: "Transferir para fila",
				fieldQueuePlaceholder: "Selecione uma fila",
				fieldConnectionLabel: "Transferir para conexão",
				fieldConnectionPlaceholder: "Selecione uma conexão",
				noOptions: "Nenhum usuário encontrado com esse nome",
				buttons: {
					ok: "Transferir",
					cancel: "Cancelar",
				},
			},
			ticketsList: {
				pendingHeader: "Aguardando",
				assignedHeader: "Atendendo",
				noTicketsTitle: "Nada aqui!",
				noTicketsMessage: "Nenhum atendimento encontrado com esse status ou termo pesquisado",
				buttons: {
					accept: "Aceitar",
					closed: "Finalizar",
					reopen: "Reabrir",
				},
			},
			ticketsListItem: {
				tooltip: {
					chatbot: "Chatbot",
					peek: "Espiar Conversa",
				},
				noQueue: "Sem fila",
			},
			ticketAdvanced: {
				selectTicket: "Selecionar Ticket",
				ticketNav: "Ticket",
				attendanceNav: "Atendimentos",
			},
			newTicketModal: {
				title: "Criar Ticket",
				titleCard: "Criar Card",
				titleLink: "Vincular Ticket",
				cardTitle: "Título do card",
				cardTitleRequired: "Digite um título para o card",
				selectUser: "Selecione o responsável",
				noUser: "Sem responsável",
				cardCreated: "Card criado com sucesso!",
				fieldLabel: "Digite para pesquisar contato",
				add: "Conversar",
				searchQueueError: "Ocorreu um erro inesperado ao buscar as filas",
				noQueue: "Sem fila",
				noContact: "Selecione um contato ou digite um número",
				selectQueue: "Selecione uma fila",
				selectConection: "Selecione uma conexão",
				defaultConnection: "Conexão padrão",
				ticketReopened: "Ticket reaberto com sucesso",
				contactNameLabel: "Nome do contato",
				contactNumberLabel: "Telefone",
				contactNameRequired: "Informe o nome do contato",
				titleEditCard: "Editar Card",
				cardDescription: "Descrição",
				cardValue: "Valor (R$)",
				linkToTicket: "Vincular ao Ticket",
				searchTicket: "Buscar ticket...",
				cardUpdated: "Card atualizado com sucesso!",
				buttons: {
					ok: "Salvar",
					cancel: "Cancelar",
				},
			},
			ticket: {
				noQueue: "Sem fila",
				unknownUser: "Usuário desconhecido",
			},
			locationPreview: {
				button: "Visualizar",
				clickToOpen: "Clique para abrir no mapa",
			},
			mainDrawer: {
				listItems: {
					dashboard: "Painel de controle",
					connections: "Conexões",
					tickets: "Atendimentos",
					quickMessages: "Respostas Rápidas",
					tasks: "Tarefas",
					contacts: "Contatos",
					queues: "Filas & Chatbot",
					tags: "Tags",
					administration: "Administração",
					users: "Usuários",
					settings: "Configurações",
					helps: "Ajuda",
					messagesAPI: "API",
					schedules: "Atividades",
					campaigns: "Disparos",
					flows: "Flowbuilder",
					annoucements: "Comunicados",
					chats: "Chat Interno",
					management: "Gestão",
					financeiro: "Financeiro",
					files: "Lista de Arquivos",
					prompts: "Neo.AI",
					queueIntegration: "Integrações",
				},
				appBar: {
					refresh: "Recarregar página",
					notRegister: "Sem notificações",
					language: "Idioma",
					darkMode: "Modo Escuro",
					lightMode: "Modo Claro",
					greeting: {
						hello: "Olá",
						welcome: "Bem-vindo ao",
						active: "Ativo até",
					},
					user: {
						profile: "Perfil",
						logout: "Sair",
					},
					internalComms: {
						title: "Comunicação Interna",
						chatTab: "Chat Interno",
						mentionsTab: "Menções",
						noMentions: "Nenhuma menção",
						markAllRead: "Marcar todas como lidas",
					},
					mentions: {
						title: "Menções",
					},
					activities: {
						title: "Lembretes",
						empty: "Nenhum lembrete para as próximas 24h",
						viewAll: "Ver todas as atividades",
					},
				},
			},
			queueIntegration: {
				title: "Integrações",
				table: {
					id: "ID",
					type: "Tipo",
					name: "Nome",
					projectName: "Nome do Projeto",
					language: "Idioma",
					lastUpdate: "Última atualização",
					actions: "Ações",
				},
				buttons: {
					add: "Adicionar Projeto",
				},
				searchPlaceholder: "Pesquisar...",
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteMessage: "Tem certeza? Esta ação não pode ser desfeita! Será removido das filas e conexões vinculadas",
				},
			},
			files: {
				title: "Lista de Arquivos",
				table: {
					name: "Nome",
					contacts: "Contatos",
					actions: "Ação",
				},
				toasts: {
					deleted: "Lista excluída com sucesso!",
					deletedAll: "Todas as listas foram excluídas com sucesso!",
				},
				buttons: {
					add: "Adicionar",
					deleteAll: "Excluir Todos",
				},
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteAllTitle: "Excluir Todos",
					deleteMessage: "Tem certeza que deseja excluir esta lista?",
					deleteAllMessage: "Tem certeza que deseja excluir todas as listas?",
				},
			},
			messagesAPI: {
				title: "API",
				labels: {
					doc: "Documentação para envio de mensagens",
					method: "Métodos de Envio",
					textMessage: "Mensagem de Texto",
					mediaMessage: "Mensagem de Mídia",
					instructions: "Instruções",
					observations: "Observações importantes",
					before1: "Antes de enviar mensagens, é necessário cadastrar o token vinculado à conexão que irá enviar as mensagens.",
					before2: "Para cadastrar, acesse o menu 'Conexões', clique no botão de editar da conexão e informe o token no campo adequado.",
					numberDescription: "O número para envio não deve conter máscaras ou caracteres especiais e deve ser composto por:",
					countryCode: "Código do País",
					number: "Número",
					textMessage2: "1. Mensagens de Texto",
					textMessageInstructions: "Abaixo está a lista de informações necessárias para enviar mensagens de texto:",
					method2: "Método",
					e: "e",
					tests: "Enviar Teste",
					mediaMessage2: "2. Mensagens de Mídia",
				},
				textMessage: {
					number: "Número",
					body: "Mensagem",
					token: "Token Cadastrado",
				},
				mediaMessage: {
					number: "Número",
					body: "Nome do arquivo",
					media: "Arquivo",
					token: "Token Cadastrado",
				},
				toasts: {
					unauthorized: "Esta empresa não tem permissão para acessar esta página! Estamos redirecionando você.",
					success: "Mensagem enviada com sucesso!",
				},
				buttons: {
					send: "Enviar",
				},
			},
			notifications: {
				noTickets: "Nenhuma notificação.",
				viewAll: "Ver todos os tickets",
			},
			quickMessages: {
				title: "Respostas Rápidas",
				searchPlaceholder: "Pesquisar...",
				noAttachment: "Sem anexo",
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
				},
				buttons: {
					add: "Adicionar",
					attach: "Anexar",
					cancel: "Cancelar",
					edit: "Editar",
				},
				toasts: {
					success: "Atalho adicionado com sucesso!",
					deleted: "Atalho removido com sucesso!",
				},
				dialog: {
					title: "Mensagem Rápida",
					shortcode: "Atalho",
					message: "Resposta",
					save: "Salvar",
					cancel: "Cancelar",
					add: "Adicionar",
					edit: "Editar",
					availableForAll: "Disponível para todos",
				},
				table: {
					shortcode: "Atalho",
					message: "Mensagem",
					actions: "Ações",
					mediaName: "Nome do Arquivo",
					status: "Status",
				},
				badges: {
					global: "Todos",
					personal: "Usuário",
				},
			},
			messageVariablesPicker: {
				label: "Variáveis Disponíveis",
				vars: {
					contactFirstName: "Primeiro Nome",
					contactName: "Nome",
					greeting: "Saudação",
					protocolNumber: "Protocolo",
					date: "Data",
					hour: "Hora",
					ticketId: "Número do Ticket",
					queue: "Fila/Departamento",
					company: "Empresa",
					user: "Atendente",
					contactNumber: "Telefone",
					contactEmail: "Email",
				},
			},
			contactLists: {
				title: "Listas de Contatos",
				table: {
					name: "Nome",
					contacts: "Contatos",
					actions: "Ações",
				},
				buttons: {
					add: "Nova Lista",
				},
				dialog: {
					name: "Nome",
					nameShort: "Nome curto",
					nameLong: "Nome longo",
					nameRequired: "Nome é obrigatório",
					company: "Empresa",
					okEdit: "Editar",
					okAdd: "Adicionar",
					add: "Adicionar",
					edit: "Editar",
					cancel: "Cancelar",
				},
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteMessage: "Esta ação não pode ser desfeita.",
				},
				toasts: {
					deleted: "Registro excluído",
					success: "Operação concluída com sucesso",
				},
				noListsFound: "Nenhuma lista encontrada",
				noListsCreated: "Nenhuma lista de contatos criada",
				tryOtherTerms: "Tente buscar com outros termos",
				clickToCreate: "Clique no botão acima para criar sua primeira lista",
			},
			contactListItems: {
				title: "Contatos",
				searchPlaceholder: "Pesquisar...",
				buttons: {
					add: "Novo",
					lists: "Listas",
					import: "Importar",
				},
				download: "Clique aqui para baixar planilha exemplo.",
				dialog: {
					name: "Nome",
					nameShort: "Nome curto",
					nameLong: "Nome longo",
					nameRequired: "Nome é obrigatório",
					number: "Número",
					numberShort: "Número curto",
					numberLong: "Número longo",
					whatsapp: "WhatsApp",
					email: "Email",
					emailInvalid: "Email inválido",
					okEdit: "Editar",
					okAdd: "Adicionar",
					add: "Adicionar",
					edit: "Editar",
					cancel: "Cancelar",
				},
				table: {
					name: "Nome",
					number: "Número",
					whatsapp: "WhatsApp",
					email: "Email",
					actions: "Ações",
				},
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteMessage: "Esta ação não pode ser desfeita.",
					importMessage: "Deseja importar contatos desta planilha? ",
					importTitle: "Importar",
				},
				toasts: {
					deleted: "Registro excluído",
				},
			},
			campaigns: {
				title: "Disparos",
				searchPlaceholder: "Pesquisar...",
				report: {
					title: "Relatório de",
					title2: "Campanha",
					of: "de",
					validContacts: "Contatos válidos",
					delivered: "Entregues",
					connection: "Conexão",
					contactList: "Lista de Contatos",
					schedule: "Agendamento",
					conclusion: "Conclusão",
				},
				config: {
					interval: "Intervalos",
					primaryIntervalTitle: "Intervalo aleatório primário entre mensagens",
					secondaryIntervalTitle: "Intervalo aleatório secundário entre mensagens",
					randomInterval: "Intervalo de Envio Aleatório",
					biggerInterval: "Intervalo Maior Após",
					greaterInterval: "Intervalo Maior de Envio",
					intervalMinLabel: "Intervalo de envio (menor)",
					intervalMaxLabel: "Intervalo de envio (maior)",
					intervalRangeError: "O intervalo máximo deve ser maior ou igual ao mínimo",
					noInterval: "Sem Intervalo",
					second: "segundo",
					seconds: "segundos",
					message: "mensagem",
					messages: "mensagens",
					notDefined: "Não definido",
					addVariable: "Adicionar Variável",
					save: "Salvar Configurações",
					shortcut: "Atalho",
					content: "Conteúdo",
					close: "Fechar",
					add: "Adicionar",
				},
				buttons: {
					add: "Novo Disparo",
					contactLists: "Listas de Contatos",
				},
				status: {
					inactive: "Inativa",
					programmed: "Agendada",
					inProgress: "Em andamento",
					canceled: "Cancelada",
					finished: "Finalizada",
				},
				table: {
					name: "Nome",
					whatsapp: "Conexão",
					contactList: "Lista de Contatos",
					status: "Status",
					scheduledAt: "Agendamento",
					completedAt: "Concluída",
					confirmation: "Confirmação",
					actions: "Ações",
					notDefined: "Não definido",
					notDefined2: "Não definido",
					notScheduled: "Não agendada",
					notConcluded: "Não concluída",
					stopCampaign: "Parar Campanha",
					startCampaign: "Iniciar Campanha",
					pauseCampaign: "Pausar Campanha",
					resetCampaign: "Reiniciar Campanha",
				},
				dialog: {
					new: "Novo Disparo",
					update: "Editar Disparo",
					readonly: "Apenas Visualização",
					form: {
						name: "Nome",
						nameShort: "Nome curto",
						nameLong: "Nome longo",
						helper: "Use variáveis como {nome}, {primeiroNome}, {numero}, {email} ou defina variáveis personalizadas.",
						nameRequired: "Nome é obrigatório",
						message1: "Mensagem 1",
						message2: "Mensagem 2",
						message3: "Mensagem 3",
						message4: "Mensagem 4",
						message5: "Mensagem 5",
						messagePlaceholder: "Conteúdo da mensagem",
						whatsapp: "Conexão",
						status: "Status",
						scheduledAt: "Agendamento",
						confirmation: "Confirmação",
						contactList: "Lista de Contatos",
						tagList: "Tag de inclusão",
						tagInclude: "Tag de inclusão",
						tagExclude: "Tag de exclusão",
						fileList: "Lista de Arquivos",
					},
					buttons: {
						add: "Adicionar",
						edit: "Atualizar",
						okadd: "Ok",
						cancel: "Cancelar Envios",
						start: "Iniciar Envios",
						pause: "Pausar Envios",
						reset: "Reiniciar Envios",
						close: "Fechar",
						attach: "Anexar",
					},
				},
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteMessage: "Esta ação não pode ser desfeita.",
				},
				toasts: {
					configSaved: "Configurações salvas",
					success: "Operação concluída com sucesso",
					cancel: "Campanha cancelada",
					start: "Campanha iniciada",
					pause: "Campanha pausada",
					reset: "Campanha reiniciada do zero",
					restart: "Campanha reiniciada",
					deleted: "Registro excluído",
				},
				noResults: "Nenhum resultado encontrado",
				noCampaigns: "Nenhuma campanha criada",
				active: "Ativo",
				inactive: "Desativado",
				editTooltip: "Editar campanha",
				deleteTooltip: "Excluir campanha",
			},
			subscription: {
				title: "Assinatura",
				validity: "Validade da assinatura",
				activeUntil: "Ativa até",
				expiredOn: "Venceu em",
				noDueDate: "Sem data de vencimento",
				chargeEmail: "Email de cobrança",
				signNow: "Assine agora!",
			},
			announcements: {
				active: "Ativo",
				inactive: "Inativo",
				title: "Comunicados",
				searchPlaceholder: "Pesquisar...",
				high: "Alta",
				medium: "Média",
				low: "Baixa",
				buttons: {
					add: "Novo Comunicado",
					contactLists: "Listas de Comunicados",
				},
				table: {
					priority: "Prioridade",
					title: "Título",
					text: "Texto",
					mediaName: "Arquivo",
					status: "Status",
					actions: "Ações",
				},
				dialog: {
					edit: "Editar Comunicado",
					add: "Novo Comunicado",
					update: "Editar Comunicado",
					readonly: "Apenas Visualização",
					form: {
						priority: "Prioridade",
						required: "Campo obrigatório",
						title: "Título",
						text: "Texto",
						mediaPath: "Arquivo",
						status: "Status",
					},
					buttons: {
						add: "Adicionar",
						edit: "Atualizar",
						okadd: "Ok",
						cancel: "Cancelar",
						close: "Fechar",
						attach: "Anexar",
					},
				},
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteMessage: "Esta ação não pode ser desfeita.",
				},
				toasts: {
					success: "Operação concluída com sucesso",
					deleted: "Registro excluído",
					info: "Esta empresa não tem permissão para acessar esta página! Estamos redirecionando você.",
				},
			},
			campaignsConfig: {
				title: "Configurações de Campanha",
			},
			queues: {
				noResults: "Nenhuma fila encontrada",
				title: "Filas & Chatbot",
				noQueues: "Nenhuma fila cadastrada",
				table: {
					id: "ID",
					name: "Nome",
					color: "Cor",
					greeting: "Mensagem de saudação",
					actions: "Ações",
					orderQueue: "Ordem da fila (bot)",
				},
				buttons: {
					add: "Adicionar fila",
					edit: "Editar",
					delete: "Excluir",
				},
				toasts: {
					success: "Fila excluída com sucesso.",
				},
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteMessage: "Tem certeza? Esta ação não pode ser desfeita! Os atendimentos nesta fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
				},
			},
			queueSelect: {
				inputLabel: "Filas",
			},
			users: {
				title: "Usuários",
				profiles: {
					admin: "Administrador",
					user: "Usuário"
				},
				table: {
					id: "ID",
					name: "Nome",
					email: "Email",
					profile: "Perfil",
					actions: "Ações",
				},
				buttons: {
					add: "Adicionar usuário",
					edit: "Editar",
					delete: "Excluir"
				},
				toasts: {
					deleted: "Usuário excluído com sucesso.",
				},
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteMessage: "Todos os dados do usuário serão perdidos. Os atendimentos abertos deste usuário serão movidos para a fila.",
				},
				noResults: "Nenhum usuário encontrado",
				noUsers: "Nenhum usuário cadastrado"
			},
			tabletSearch: {
				open: "Buscar",
				clear: "Limpar busca",
				active: "Busca ativa",
				results: "resultados",
				moreActions: "Mais ações",
			},
			todolist: {
				input: "Nova tarefa",
				buttons: {
					add: "Adicionar",
					save: "Salvar",
				},
			},
			helps: {
				title: "Central de Ajuda",
			},
			schedules: {
				noResultsWithFilters: "Nenhum resultado com os filtros atuais",
				clearFilters: "Limpar filtros",
				title: "Atividades",
				noResults: "Nenhuma atividade encontrada",
				noSchedules: "Nenhuma atividade cadastrada",
				confirmationModal: {
					deleteTitle: "Tem certeza que deseja excluir esta Atividade?",
					deleteMessage: "Esta ação não pode ser desfeita.",
					deleteTaskTitle: "Tem certeza que deseja excluir esta tarefa?",
					deleteTaskMessage: "Esta ação não pode ser desfeita.",
				},
				table: {
					contact: "Contato",
					body: "Mensagem",
					sendAt: "Data de Agendamento",
					sentAt: "Data de Envio",
					status: "Status",
					actions: "Ações",
				},
				messages: {
					date: "Data",
					time: "Hora",
					event: "Evento",
					allDay: "Dia Inteiro",
					week: "Semana",
					work_week: "Atividades",
					day: "Dia",
					month: "Mês",
					previous: "Anterior",
					next: "Próximo",
					yesterday: "Ontem",
					tomorrow: "Amanhã",
					today: "Hoje",
					agenda: "Agenda",
					noEventsInRange: "Não há atividades neste período.",
					showMore: "mais",
				},
				activityTypes: {
					call: "Ligação",
					meeting: "Reunião",
					message: "Mensagem",
					email: "Email",
					visit: "Visita",
					activity: "Tarefa",
				},
				buttons: {
					add: "Nova Atividade",
					edit: "Editar",
					delete: "Deletar",
				},
				filters: {
					allUsers: "Todos",
					allTypes: "Todas",
				},
				tooltips: {
					viewDescription: "Ver descrição",
				},
				activityTypes: {
					call: "Ligação",
					meeting: "Reunião",
					message: "Mensagem",
					email: "Email",
					visit: "Visita",
					activity: "Tarefa",
					confirmationModal: {
						deleteTitle: "Excluir Tipo de Atividade",
						deleteMessage: "Tem certeza que deseja excluir este tipo de atividade?",
					},
					toasts: {
						created: "Tipo de atividade criado!",
						updated: "Tipo de atividade atualizado!",
						deleted: "Tipo de atividade excluído!",
					},
				},
				statuses: {
					schedule: {
						sent: "Enviado",
						error: "Erro",
						late: "Atrasado",
						soon: "Em breve",
						scheduled: "Agendado",
					},
					task: {
						done: "Concluída",
						late: "Atrasada",
						soon: "Em breve",
						pending: "Pendente",
					},
				},
				activityModal: {
					title: "Nova Atividade",
					editTitle: "Editar Atividade",
					editScheduleTitle: "Editar Agendamento",
					board: "Quadro",
					allBoards: "Todos",
					type: "Tipo",
					connection: "Conexão",
					contact: "Contato",
					description: "Descrição",
					message: "Mensagem",
					when: "Data/Hora",
					attachment: "Anexar",
					cancel: "Cancelar",
					save: "Salvar",
				},
				views: {
					list: "Lista",
					calendar: "Calendário",
				},
				toasts: {
					deleted: "Atividade excluída com sucesso.",
					created: "Atividade criada com sucesso.",
					ticketNotFound: "Atividade não criada porque o ticket não existe.",
				},
			},
			tags: {
				title: "Tags",
				confirmationModal: {
					deleteTitle: "Tem certeza que deseja excluir esta Tag?",
					deleteMessage: "Esta ação não pode ser desfeita.",
					deleteAllMessage: "Tem certeza que deseja excluir todas as Tags?",
					deleteAllTitle: "Excluir Todas",
				},
				table: {
					name: "Nome",
					color: "Cor",
					tickets: "Registros Marcados",
					actions: "Ações",
				},
				buttons: {
					delete: "Excluir tag",
					add: "Nova Tag",
					deleteAll: "Excluir Todas",
				},
				toasts: {
					deletedAll: "Todas as Tags excluídas com sucesso!",
					deleted: "Tag excluída com sucesso.",
				},
				noResults: "Nenhum resultado encontrado",
				noTags: "Nenhuma tag criada",
			},
			settings: {
				schedulesUpdated: "Horários atualizados com sucesso.",
				success: "Configurações salvas com sucesso.",
				title: "Configurações",
				tabs: {
					services: "Serviços",
					options: "Opções",
					schedules: "Horários",
					companies: "Empresas",
					plans: "Planos",
					billing: "Cobranças",
					helps: "Ajuda",
				},
				options: {
					toasts: {
						success: "Operação atualizada com sucesso.",
						error: "Não foi possível salvar a configuração.",
					},
					fields: {
						ratings: {
							title: "Avaliações",
							disabled: "Desabilitado",
							enabled: "Habilitado",
						},
						expedientManager: {
							title: "Gerenciador de Horário Comercial",
							queue: "Fila",
							company: "Empresa",
						},
						ignoreMessages: {
							title: "Ignorar Mensagens de Grupos",
						},
						acceptCall: {
							title: "Aceitar Chamada",
							disabled: "Não aceitar",
							enabled: "Aceitar",
						},
						chatbotType: {
							title: "Tipo de Chatbot",
							text: "Texto",
						},
						language: {
							title: "Idioma",
						},
						sendGreetingAccepted: {
							title: "Enviar saudação ao aceitar ticket",
						},
						sendMsgTransfTicket: {
							title: "Enviar mensagem na transferência",
						},
						sendGreetingMessageOneQueues: {
							title: "Enviar saudação em fila única",
						},
						disabled: "Desabilitado",
						active: "Ativo",
						enabled: "Habilitado",
					},
					updating: "Atualizando...",
					tabs: {
						integrations: "INTEGRAÇÕES",
					},
				},
				helps: {
					toasts: {
						errorList: "Não foi possível carregar a lista de registros",
						errorOperation: "Não foi possível completar a operação",
						error: "Não foi possível completar a operação. Verifique se existe ajuda com o mesmo nome ou se os campos foram preenchidos corretamente",
						success: "Operação concluída com sucesso!",
					},
					buttons: {
						clean: "Limpar",
						delete: "Excluir",
						save: "Salvar",
					},
					grid: {
						title: "Título",
						description: "Descrição",
						video: "Vídeo",
					},
					confirmModal: {
						title: "Excluir Registro",
						confirm: "Realmente deseja excluir este registro?",
					},
				},
				company: {
					newCompany: "Nova Empresa",
					editCompany: "Editar Empresa",
					subscriptionSection: "Plano e assinatura",
					planChange: {
                        financeUnavailable: "O Asaas não está configurado para consultar cobranças e assinaturas.",
                        financeLoadError: "Não foi possível consultar os dados financeiros. Tente novamente.",
                        retryFinance: "Tentar novamente",

						title: "Revisar alteração de plano", company: "Empresa", current: "Plano atual", target: "Novo plano",
						cycleValue: "Valor por ciclo", usage: "Uso atual e limite do novo plano",
						users: "Usuários", connections: "Conexões", queues: "Filas", blocked: "O uso atual excede o limite do novo plano:",
						featuresLost: "Recursos que deixarão de estar disponíveis", back: "Voltar", confirm: "Confirmar", applying: "Confirmando…",
						editCompany: "Editar empresa", separatePassword: "Salve a alteração de senha separadamente antes de mudar o plano.",
						previewError: "Não foi possível preparar a revisão. Verifique o plano e os dados financeiros da empresa.",
						confirmError: "Não foi possível confirmar a alteração. Revise os dados e tente novamente.",
						rejected: "A alteração não foi aplicada. Revise os dados antes de tentar novamente.",
						statusError: "Não foi possível verificar a alteração. Tente novamente ou procure o suporte antes de iniciar outra.",
						storageError: "Não foi possível guardar o identificador da alteração neste navegador.",
						                        paidCycle: "Ciclo pago: de {{start}} até a renovação em {{end}}.",
                        nextCycle: "Próximo ciclo",
                        newCharge: "Nova cobrança",
                        newCycleValue: "Ciclo completo do novo plano",
                        unusedCredit: "Crédito: {{count}} de {{total}} dias não usados",
                        amountDue: "Total a pagar",
                        paymentDue: "Vencimento",
                        upgradeActivation: "Novo plano após o pagamento",
                        upgradeExplanation: "O vencimento corresponde ao dia seguinte à solicitação. O pagamento confirmado ativa o novo plano e inicia um ciclo completo nessa data. O crédito fica fixado nesta solicitação; a cobertura paga e a carência do plano atual continuam valendo enquanto você aguarda.",
                        downgradeActivation: "Mudança em {{date}}",
                        downgradeExplanation: "O plano atual segue até o fim do ciclo pago. Na virada, o novo plano será aplicado após conferir os limites. Não há crédito por esta redução; o acesso no próximo ciclo depende do pagamento, com a carência habitual.",
                        fullRenewal: "As renovações seguintes terão o valor integral de {{value}} por ciclo.",
                        downgradeLimits: "Antes da vigência, reduza o uso destes recursos. A mudança ficará em conferência se os limites continuarem excedidos:",
                        awaitingPayment: "Aguardando pagamento",
                        scheduled: "Mudança agendada para {{date}}",
                        reviewRequired: "Conferência necessária",
                        verifying: "Verificando solicitação",
                        lookupFailed: "Não foi possível consultar a solicitação",
                        requestFor: "Alteração de plano de",
                        openCharge: "Abrir cobrança",
                        pendingCharge: "Cobrança de {{value}} com vencimento em {{date}}.",
                        awaitingExplanation: "O plano atual permanece até a confirmação do pagamento, respeitando a cobertura paga e a carência habitual.",
                        scheduledExplanation: "O plano atual segue até {{date}}. A mudança e os limites serão conferidos nessa data.",
                        assignedExplanation: "O plano {{plan}} já foi aplicado. O novo ciclo de uso aguarda a confirmação do pagamento, com a carência habitual.",
                        limitReview: "O uso excede os limites do novo plano. Reduza usuários, conexões ou filas e verifique novamente. Nenhum recurso foi excluído.",
                        reviewExplanation: "A alteração precisa de conferência financeira. Revise a situação antes de iniciar outra solicitação.",
                        otherAdministrator: "Esta solicitação foi confirmada por outro administrador. Você pode consultar a situação; o processamento continua pelo sistema.",
                        companyNumber: "Empresa {{id}}",
                        pendingOperation: "Esta empresa já tem uma alteração de plano pendente. Consulte a situação antes de iniciar outra.",
                        checkStatus: "Verificar e retomar",
                        useCampaigns: "Campanhas", useSchedules: "Agendamentos", useInternalChat: "Chat interno", useExternalApi: "API externa", useKanban: "Kanban", useOpenAi: "OpenAI", useAutomation: "Automações", useIntegrations: "Integrações"
					},
					toasts: {
						errorList: "Não foi possível carregar a lista de registros",
						errorOperation: "Não foi possível completar a operação",
						error: "Não foi possível completar a operação. Verifique se existe empresa com mesmo nome ou se os campos foram preenchidos corretamente",
						success: "Operação concluída com sucesso!",
					},
					confirmModal: {
						title: "Excluir Registro",
						confirm: "Realmente deseja excluir este registro?",
						message: "Tem certeza que deseja excluir esta empresa?",
					},
					form: {
						cpfCnpj: "CPF/CNPJ",
						cpfCnpjRequired: "CPF/CNPJ é obrigatório",
						cpfCnpjInvalid: "CPF/CNPJ inválido",
						name: "Nome",
						email: "Email",
						phone: "Telefone",
						plan: "Plano",
						status: "Status",
						trial: "Trial",
						active: "Ativo",
						yes: "Sim",
						no: "Não",
						campanhas: "Campanhas",
						enabled: "Habilitado",
						disabled: "Desabilitado",
						dueDate: "Data de vencimento",
						recurrence: "Recorrência",
						monthly: "Mensal",
						expire: "Expiração",
						createdAt: "Criado Em",
					},
					buttons: {
						cancel: "Cancelar",
						clear: "Limpar",
						delete: "Excluir",
						expire: "+ Expiração",
						user: "Usuário",
						save: "Salvar",
					},
				},
				schedules: {
					form: {
						weekday: "Dia da semana",
						initialHour: "Horário inicial",
						finalHour: "Horário final",
						save: "Salvar",
					},
				},
				settings: {
					userCreation: {
						name: "Criação de usuário",
						options: {
							enabled: "Habilitado",
							disabled: "Desabilitado",
						},
					},
				},
			},
			messagesList: {
				header: {
					assignedTo: "Atribuído à:",
					buttons: {
						return: "Retornar",
						resolve: "Resolver",
						reopen: "Reabrir",
						accept: "Aceitar",
						download: "Download",
						options: "Opções",
					},
				},
				today: "Hoje",
				yesterday: "Ontem",
				quotedMessageNotFound: "Mensagem citada não encontrada",
				goToQuotedMessage: "Ir para a mensagem citada",
				audioSpeed: "Velocidade do áudio: {{speed}}x",
				lostCall: "Chamada de voz/vídeo perdida às",
				deletedMessage: "Esta mensagem foi apagada pelo contato",
				edited: "Editado",
				saudation: "Diga olá ao seu novo contato!",
				internalNoteBy: "Nota por {{author}}",
				internalNoteAuthor: "Equipe",
				noteRemoved: "Nota removida com sucesso!",
				transferNote: {
					viewTicket: "Ver ticket #{{id}}",
					viewPreviousTicket: "Ver ticket anterior (#{{id}})",
				},
				vcard: {
					startConversation: "Conversar",
					multipleContacts: "Contém {{count}} contatos. Selecione um para iniciar a conversa.",
					noPhoneFound: "Não encontramos um telefone válido neste cartão.",
					ticketCreated: "Ticket criado a partir do contato.",
					ticketCreatedMultiple: "Ticket criado para {{contact}}.",
					ticketAlreadyOpen: "Já existe um ticket aberto para este contato. Abrindo conversa atual.",
					missingUserOwner: "Não foi possível identificar o responsável do ticket para herdar a conversa."
				},
				interactiveButtons: {
					title: "Mensagem com botões",
				},
				interactiveList: {
					title: "Mensagem com lista",
					viewOptions: "Ver opções",
				},
			},
			wabaTemplates: {
				title: "Templates WABA",
				buttons: {
					new: "Novo Template",
					close: "Fechar",
					cancel: "Cancelar",
					create: "Criar Template",
					delete: "Excluir",
				},
				table: {
					status: "Status",
					name: "Nome",
					category: "Categoria",
					language: "Idioma",
					actions: "Ações",
				},
				status: {
					APPROVED: "Aprovado",
					PENDING: "Pendente",
					REJECTED: "Rejeitado",
				},
				creator: {
					title: "Criar Template",
				},
				form: {
					name: "Nome do Template",
					nameHelp: "Apenas letras minúsculas, números e sublinhado (ex: oferta_especial)",
					category: "Categoria",
					language: "Idioma",
					header: "Cabeçalho (Opcional)",
					headerNone: "Nenhum",
					headerText: "Texto",
					headerImage: "Imagem",
					headerVideo: "Vídeo",
					headerDocument: "Documento",
					body: "Corpo da Mensagem (Obrigatório)",
					bodyPlaceholder: "Texto da Mensagem",
					bodyHelp: "Use {{1}}, {{2}} para variáveis",
					footer: "Rodapé (Opcional)",
					footerPlaceholder: "Texto do Rodapé",
					buttons: "Botões (Opcional)",
					addButton: "Adicionar Botão",
				},
				picker: {
					title: "Templates",
					noTemplates: "Nenhum template aprovado disponível",
					selectTemplate: "Selecione um template",
					variables: "Variáveis",
					variablePlaceholder: "Valor da variável {{index}}",
					send: "Enviar Template",
					cancel: "Cancelar",
				},
				toasts: {
					created: "Template criado com sucesso!",
					deleted: "Template excluído com sucesso!",
					sent: "Template enviado com sucesso!",
					error: "Erro ao processar template",
				},
				confirmDelete: "Tem certeza que deseja excluir o template \"{{name}}\"?",
			},
			messagesInput: {
				placeholderOpen: "Digite uma mensagem",
				placeholderClosed: "Reabra ou aceite este ticket para enviar uma mensagem.",
				signMessage: "Assinar",
				sendMessage: "Enviar mensagem",
				sendFile: "Enviar arquivo",
				attachMenu: {
					title: "Anexar",
					file: "Anexo",
					contact: "Contato",
					signature: "Assinatura",
					template: "Templates",
				},
				contactDialog: {
					title: "Enviar contato",
					search: "Buscar contato pelo nome",
					empty: "Nenhum contato encontrado",
					cancel: "Cancelar",
					unknown: "Contato sem nome",
					missingNumber: "Este contato não possui número válido.",
				},
				recordAudio: "Gravar áudio",
				noteToggle: "Nota",
				placeholderNote: "Digite uma nota interna",
				placeholderEditing: "Edite a mensagem e pressione Enter para salvar.",
				saveNote: "Salvar nota",
				noteSaved: "Nota salva com sucesso!",
				noteError: "Não foi possível salvar a nota",
				ticketNotOpen: "Este ticket não está aberto. Não é possível enviar mensagens.",
				clearReply: "Limpar resposta",
				cancelRecording: "Cancelar gravação",
				sendAudio: "Enviar áudio",
				cancelUpload: "Cancelar envio",
				sendErrorPending: "Não foi possível enviar agora. A mensagem permanecerá pendente.",
				replyPreview: {
					location: "Localização",
					contact: "Contato",
					contacts: "{{count}} contatos"
				},
				editingMode: "Editando mensagem",
				saveEdit: "Salvar edição",
				cancelEdit: "Cancelar edição",
			},
			contactDrawer: {
				header: "Dados do Contato",
				buttons: {
					edit: "Editar contato",
				},
				extraInfo: "Outras informações",
			},
			contactDocuments: {
				status: {
					pending: "Ass. Pendente",
					signed: "Doc. Finalizado",
					rejected: "Doc. Rejeitado",
				},
			},
			fileModal: {
				title: {
					add: "Adicionar lista de arquivo",
					edit: "Editar lista de arquivo",
				},
				buttons: {
					okAdd: "Salvar",
					okEdit: "Editar",
					cancel: "Cancelar",
					fileOptions: "Adicionar arquivo",
				},
				form: {
					name: "Nome da lista de arquivo",
					message: "Detalhes da lista",
					fileOptions: "Lista de arquivo",
					extraName: "Mensagem para enviar com arquivo",
					extraValue: "Valor da opção",
				},
				formErrors: {
					name: {
						required: "Nome é obrigatório",
						short: "Nome muito curto",
					},
					message: {
						required: "Mensagem é obrigatória",
					},
				},
				success: "Lista de arquivo salva com sucesso!",
			},
			ticketOptionsMenu: {
				schedule: "Agendamento",
				delete: "Excluir",
				transfer: "Transferir",
				exportHistory: "Salvar histórico",
				exportSuccess: "Histórico exportado com sucesso!",
				registerAppointment: "Observações do Contato",
				appointmentsModal: {
					title: "Observações do Contato",
					textarea: "Observação",
					placeholder: "Insira aqui a informação que deseja registrar",
				},
				confirmationModal: {
					title: "Excluir ticket",
					titleFrom: "do contato ",
					message: "Atenção! Todas as mensagens relacionadas a esse ticket serão perdidas.",
				},
				buttons: {
					delete: "Excluir",
					cancel: "Cancelar",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Cancelar",
				},
			},
			messageOptionsMenu: {
				delete: "Excluir",
				reply: "Responder",
				edit: "Editar",
				react: "Reagir",
				confirmationModal: {
					title: "Apagar mensagem?",
					message: "Esta ação não pode ser revertida.",
				},
				editModal: {
					title: "Editar mensagem",
					placeholder: "Digite a nova mensagem...",
					save: "Salvar",
					cancel: "Cancelar",
				},
				editErrors: {
					windowExpired: "Tempo limite para edição expirado (15 minutos)",
					mediaMessage: "Mensagens com mídia não podem ser editadas",
					notFromMe: "Apenas mensagens enviadas por você podem ser editadas",
					emptyMessage: "A mensagem não pode estar vazia",
					genericError: "Não foi possível editar a mensagem",
				},
			},
			backendErrors: {
        ERR_COMPANY_CPF_CNPJ_REQUIRED: "CPF/CNPJ é obrigatório.",
        ERR_COMPANY_INVALID_CPF_CNPJ: "CPF/CNPJ inválido. Confira o número informado.",
        ERR_COMPANY_CPF_CNPJ_REJECTED: "O Asaas recusou este CPF/CNPJ. Confira o número e tente novamente.",
        ERR_COMPANY_CPF_CNPJ_SYNC_FAILED: "Não foi possível atualizar o CPF/CNPJ no Asaas. Tente novamente.",
        ERR_PLAN_CHANGE_CUSTOMER_DOCUMENT_REQUIRED: "Informe o CPF/CNPJ da empresa para continuar com o upgrade.",
        ERR_PLAN_CHANGE_PROVIDER_REJECTED: "O Asaas recusou a cobrança e nenhum valor foi gerado. Revise os dados da empresa e tente novamente.",
        ERR_OPENAI_MODEL_UNSUPPORTED: "Modelo de IA não reconhecido. Selecione GPT 6 Luna, GPT 6.1 Sol ou GPT 6 Astra.",
				ERR_SCHEDULE_DELIVERY_IMMUTABLE: "Este envio está em andamento ou precisa de verificação. Aguarde a confirmação antes de alterar ou excluir a atividade.",
				ERR_SCHEDULE_DISPATCH_REQUIRES_REVIEW: "Envio em verificação. Confira o histórico e aguarde a confirmação antes de tentar novamente.",
				ERR_TASK_COMMERCIAL_CONTEXT_MISMATCH: "O atendimento vinculado a esta atividade mudou. Atualize a página e confira o destino antes de continuar.",
				ERR_KANBAN_MOVE_CONFLICT: "Este item já mudou de etapa. Atualize o quadro e tente novamente.",
					ERR_SUPPORT_BETA_EXTERNAL_ACTION_DISABLED: "Esta ação está desativada neste ambiente de homologação.",
				ERR_COMPANY_WEAK_PASSWORD: "A senha deve ter no mínimo 8 caracteres, incluindo maiúscula, minúscula e número",
				ERR_COMPANY_PASSWORD_REQUIRED: "Senha é obrigatória",
				ERR_GLOBAL_AI_LIMIT_REACHED: "Limite de uso de IA do período de trial atingido. Configure sua própria chave para continuar.",
				ERR_INTERNAL_SERVER_ERROR: "Ocorreu um erro inesperado. Tente novamente mais tarde",
				ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
				ERR_NO_DEF_WAPP_FOUND: "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
				ERR_WAPP_NOT_INITIALIZED: "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
				ERR_CLOUD_API_CONNECT_FAILED: "Falha ao conectar na API oficial do WhatsApp. Verifique as credenciais.",
				ERR_WAPP_CHECK_CONTACT: "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
				ERR_WAPP_INVALID_CONTACT: "Este não é um número de WhatsApp válido.",
				ERR_WAPP_DOWNLOAD_MEDIA: "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
				ERR_INVALID_CREDENTIALS: "Erro de autenticação. Por favor, tente novamente.",
				ERR_USER_DONT_EXISTS: "Usuário não encontrado. Verifique o email fornecido.",
				ERR_SENDING_WAPP_MSG: "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
				ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
				ERR_OTHER_OPEN_TICKET: "Já existe um ticket aberto para este contato.",
				ERR_SESSION_EXPIRED: "Sessão expirada. Por favor faça login.",
				ERR_SESSION_REVOKED: "Sua sessão foi encerrada porque houve login em outro dispositivo.",
				ERR_NO_AUTH_TOKEN: "Sessão não encontrada. Faça login novamente.",
				ERR_INVALID_ACCESS_TOKEN: "Token de acesso inválido. Tentando renovar sua sessão.",
				ERR_USER_CREATION_DISABLED: "A criação de usuário foi desabilitada pelo administrador.",
				ERR_KANBAN_EXECUTION_MODE_INVALID: "Escolha um modo de execução válido na ação Adicionar ao Kanban.",
				ERR_KANBAN_EXECUTION_MODE_MIXED: "Use o mesmo modo de execução em todas as ações Adicionar ao Kanban desta sequência.",
				ERR_KANBAN_CARD_TITLE_TEMPLATE_INVALID: "O modelo de nome do Card contém uma variável ou formato inválido.",
				ERR_KANBAN_CARD_TITLE_TOO_LONG: "O nome resultante do Card excede o limite de 255 caracteres.",
				ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
				ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
				ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
				ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
				ERR_NO_TICKET_FOUND: "Nenhum ticket encontrado com este ID.",
				ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
				ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
				ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
				ERR_CREATING_TICKET: "Erro ao criar ticket no banco de dados.",
				ERR_FETCH_WAPP_MSG: "Erro ao buscar a mensagem no WhatsApp, talvez ela seja muito antiga.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS: "Esta cor já está em uso, escolha outra.",
				ERR_WAPP_GREETING_REQUIRED: "A mensagem de saudação é obrigatória quando há mais de uma fila.",
				ERR_FILE_TOO_LARGE: "O arquivo excede o limite permitido.",
				ERR_MEDIA_IMAGE_TOO_LARGE: "Imagens podem ter no máximo {{limit}}MB.",
				ERR_MEDIA_VIDEO_TOO_LARGE: "Vídeos podem ter no máximo {{limit}}MB.",
				ERR_MEDIA_AUDIO_TOO_LARGE: "Áudios podem ter no máximo {{limit}}MB.",
				ERR_MEDIA_DOCUMENT_TOO_LARGE: "Documentos podem ter no máximo {{limit}}MB.",
				ERR_CAMPAIGN_MEDIA_REQUIRED: "Esta campanha exige mídia anexada. Anexe uma imagem antes de iniciar.",
				ERR_INVALID_NUMBER_FORMAT: "Formato de número inválido. O número deve ter no mínimo 8 dígitos.",
				ERR_NOT_BRAZILIAN_NUMBER: "Número internacional inválido. Não foi possível verificar este número no WhatsApp.",
				ERR_INVALID_DDD: "DDD inválido. O código de área deve estar entre 11 e 99.",
				ERR_INVALID_WHATSAPP_NUMBER: "Número de WhatsApp inválido. Verifique se o número está correto e possui WhatsApp ativo.",
				ERR_NO_QUEUE_ACCESS: "Sem permissão para acessar a fila {{queueName}}",
				ERR_TICKET_ASSIGNED_OTHER_USER: "Ticket atribuído a {{userName}}",
				ERR_PENDING_TICKET_READONLY: "Ticket em modo pendente. Não é possível enviar mensagens.",
				ERR_CLOSED_TICKET: "Este ticket está fechado. Não é possível enviar mensagens. Por favor, reabra o ticket primeiro.",
				ERR_TRANSFER_VIEW_TARGET_REQUIRED: "Não foi possível identificar o ticket relacionado à transferência.",
				ERR_TRANSFER_VIEW_INVALID_SOURCE: "Ticket de origem inválido para a visualização.",
				ERR_TRANSFER_VIEW_INVALID_TARGET: "Ticket relacionado inválido para a visualização.",
				ERR_TRANSFER_VIEW_SOURCE_NOT_FOUND: "Ticket de origem da transferência não foi encontrado.",
				ERR_TRANSFER_VIEW_TARGET_NOT_FOUND: "Ticket relacionado à transferência não foi encontrado.",
				ERR_TRANSFER_VIEW_FORBIDDEN: "Você não tem permissão para visualizar o histórico deste ticket transferido."
			},
			task: {
				title: "Editar tarefa",
				form: {
					description: "Descreva a atividade...",
					when: "Quando?",
				},
				toasts: {
					deleted: "Tarefa excluída com sucesso.",
				},
				success: "Tarefa salva com sucesso!",
				error: "Erro ao salvar tarefa!",
			},
			flowBuilderTransferencia: {
				title: "Configurar Transferência de Conexão",
				save: "Salvar",
				cancel: "Cancelar",
				destination: "Destino da Transferência",
				destinationConnection: "Conexão de Destino",
				destinationQueue: "Fila de Destino (Opcional)",
				noQueue: "Sem Fila",
				options: "Opções de Transferência",
				sendMessages: "Enviar mensagens (\"Transferindo atendimento...\" e \"Atendimento transferido com sucesso.\")",
				keepTags: "Manter tags existentes do ticket",
				infoTitle: "Como funciona:",
				infoLine1: "O ticket atual será finalizado na conexão de origem",
				infoLine2: "Um novo ticket será criado/reaberto na conexão de destino",
				infoLine3: "O contexto do flow será mantido e continuará no ticket de destino",
				infoLine4: "As mensagens coletadas anteriormente serão preservadas",
				selectConnection: "Selecione uma conexão de destino",
				connected: "Conectado",
				disconnected: "Desconectado",
			},
			flowBuilderMenuModal: {
				explanationMessage: "Mensagem de explicação do menu",
				addOption: "Adicionar Opção",
				typeN: "Digite {{number}}",
				typeOption: "Digite opção",
				optionsFormat: "Formato das opções",
				formatDot: "1. Opção",
				formatDash: "1 - Opção",
				formatBrackets: "[1] Opção",
				formatEmoji: "1️⃣ Opção",
				titleAdd: "Adicionar menu ao fluxo",
				titleEdit: "Editar menu",
				buttonAdd: "Adicionar",
				buttonSave: "Salvar",
			},
		}
	},
};

export { messages };
